import React from "react"
import PropTypes from "prop-types"
import Grid from "@mui/material/Grid"
import { AdvancedImage } from "@cloudinary/react"
import InstructorIcon from "@mui/icons-material/Face"
import CarIcon from "@mui/icons-material/DirectionsCar"
import DashcamIcon from "@mui/icons-material/Videocam"

import ImageTextBlock from "../template-parts/product-marketing/ImageTextBlock"
import {
  coastAcademyVehicleImg,
  lazyLoadPreset,
} from "../../utils/cloudinaryImageUtils"
import Section from "../template-parts/product-marketing/Section"
import IconTextBlock from "../template-parts/product-marketing/IconTextBlock"

const safetyFeatures = [
  {
    head: "Instructors you can trust",
    text: "We're one of the only driving schools to do independent background and drug screens on every employee",
    icon: <InstructorIcon />,
  },
  {
    head: "Marked cars with a second brake",
    text: "Every Coastline car has a second instructor brake, is clearly marked as a driving school vehicle and is inspected by a BAR-certified mechanic",
    icon: <CarIcon />,
  },
  {
    head: "Dashcam in every car",
    text: "We record video and audio inside and outside the car for everyone's safety",
    icon: <DashcamIcon />,
  },
]

const Safety = ({ location }) => (
  <Section
    head={`Safety Lives ${location}`}
    subhead="We go above and beyond expectations to provide a safe learning experience."
    style={{
      background: "#fafafa",
    }}
  >
    <div>
      <ImageTextBlock
        image={
          <AdvancedImage
            cldImg={coastAcademyVehicleImg}
            style={{ borderRadius: 60 }}
            plugins={[lazyLoadPreset]}
            alt="Coastline Corolla"
            width={600}
          />
        }
      >
        <Grid container spacing={3}>
          {safetyFeatures.map((feature) => (
            <Grid item xs={12} key={feature.head}>
              <IconTextBlock
                head={feature.head}
                text={feature.text}
                icon={feature.icon}
              />
            </Grid>
          ))}
        </Grid>
      </ImageTextBlock>
    </div>
  </Section>
)
Safety.propTypes = {
  location: PropTypes.string,
}
Safety.defaultProps = {
  location: "Here",
}

export default Safety
